var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.286c0-.541.147-1.083.588-1.489l4.853-4.468a.754.754 0 011.03 0 .62.62 0 010 .948l-4.853 4.468a.62.62 0 000 .948L8.47 18.16a.62.62 0 010 .948.754.754 0 01-1.03 0L2.588 14.64c-.44-.27-.588-.812-.588-1.354z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.882 13.285c0-.406.294-.677.736-.677h17.647c.44 0 .735.271.735.677s-.294.677-.735.677H3.618c-.442 0-.736-.27-.736-.677z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBig);
export default __webpack_public_path__ + "static/media/arrow-left-big.c2ec28d6d727e235dc045cd001f0d63d.svg";
export { ForwardRef as ReactComponent };